import { useEffect } from "react";
import { Form, Col, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";
import usePost from "../../../global/hooks/usePost";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { SipIcon } from "../../../assets/images/vectors/SideBarIcons/SipIcon";
import useGet from "../../../global/hooks/useGet";

export const AddByCountSipForm = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const postUrl = `${process.env.REACT_APP_API_URL}/api/sips/range-create/`;
  const getUrl = `${process.env.REACT_APP_API_URL}/api/sips/?limit=10&sort_by=SipId&order=desc`;

  const { data } = useGet(getUrl);

  const {
    data: postData,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  const onFinish = async (values) => {
    try {
      const payload = {
        startSIPId: Number(values.startSIPId), // Ensure SipId is a number
        count: Number(values.count), // Ensure count is a number
      };
      await postAction(payload);
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.log(error);
    }
  };

  const onReset = () => {
    // form.resetFields();
    navigate(-1);
  };

  useEffect(() => {
    if (data?.data && Array.isArray(data?.data)) {
      form.setFieldValue("startSIPId", Number(data?.data[0]?.SipId) + 1);
    }
  }, [data]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postError && postData) {
      openConfirmNotification("Success");
      setTimeout(() => {
        navigate(-1);
      }, 200);
    }
  }, [postError, postData]);

  // Set default field value

  const breadcrumbItems = [
    {
      label: "SIP",
      href: "/sip",
    },
    {
      label: "Add By Count",
      href: "/addSipByCount",
    },
  ];

  const buttonsData = [
    {
      label: "Apply",
      icon: <CheckCircleOutlined />,
      onClick: () => form.submit(),
    },
    {
      label: "Cancel",
      icon: <CloseOutlined />,
      onClick: onReset,
    },
  ];

  return (
    <div>
      <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
        <CommonButton buttonsData={buttonsData} />
      </CommonBreadcrumb>
      <>
        <Form
          validateTrigger={"onChange"}
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          layout={"vertical"}
          autoComplete={"off"}
        >
          <div className="mt-6 border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <SipIcon className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                SIP
              </span>
            </div>
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Start SIP ID"
                    name="startSIPId"
                    type="number"
                    disable={id}
                    required
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Count"
                    name="count"
                    type="number"
                    disable={id}
                    required
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Form>
      </>
    </div>
  );
};
